var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message",class:_vm.dynamicClasses},[_c('p',{staticClass:"message-text"},[_vm._v(_vm._s(_vm.$t("login.session_expired")))])])}
var staticRenderFns = []

export { render, staticRenderFns }